<template lang="pug">
.main-content
  .form-group
    label.col-md-12 動作環境：OS
    .col-md-12
      el-input(type='text',value='', v-model='teachingAssistData.machine_env.os')
  .form-group
    label.col-md-12 動作環境：CPU
    .col-md-12
      el-input(type='text',value='', v-model='teachingAssistData.machine_env.cpu')
  .form-group
    label.col-md-12 動作環境：メモリ
    .col-md-12
      el-input(type='text',value='', v-model='teachingAssistData.machine_env.memory')
  .form-group
    label.col-md-12 動作環境：HDD
    .col-md-12
      el-input(type='text',value='', v-model='teachingAssistData.machine_env.hdd')
  .form-group
    label.col-md-12  動作環境：モニタ
    .col-md-12
      el-input(type='text',value='', v-model='teachingAssistData.machine_env.monitor')
  .form-group
    label.col-md-12  動作環境：グラフィック
    .col-md-12
      el-input(type='text',value='', v-model='teachingAssistData.machine_env.graphic')
  .form-group
    label.col-md-12 動作環境：USBポート
    .col-md-12
      el-input(type='text',value='', v-model='teachingAssistData.machine_env.usb')
  .form-group
    label.col-md-12 使用環境
    .col-md-12
      el-input(type='text',value='', v-model='teachingAssistData.user_env[0]')
      el-input(type='text',value='', v-model='teachingAssistData.user_env[1]')
</template>

<script>
export default {
  name: 'TeachingAssist',
  data () {
    return {
    }
  },
  props: {
    teachingAssistData: Object
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/components/swan/techInfo/TeachingAssist.vue